module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_3-cc192a047068a86ce12a14a8d5fcf2a9.png";